import React from 'react';
import PropTypes from 'prop-types';
import jsLang from '../../lib/jslang';
import crossIcon from '../../../svg/cross.svg';

const Alert = ({
    className, dismissable, icon, id, show, text, type,
}) => {
    const renderIcon = () => (
        <i className="v-align-content-centre m-r-xs" title={ text }>
            <img key="alert-icon" width="24" height="24" src={ icon } aria-labelledby="alert-icon" alt="Alert icon" />
        </i>
    );

    const renderCloseButton = () => (
        <button
            type="button"
            data-close-el={ id }
            title={ jsLang.get('common.close') }
            aria-label={ jsLang.get('common.close') }
            className="v-align-content-centre m-l-xs"
        >
            <img key="error-icon" width="16" height="16" src={ crossIcon } alt="Close icon" />
        </button>
    );

    return (
        <div
            id={ id }
            className={ `${className} alert--${type} ${dismissable ? 'alert--dismissible toggle' : 'flex'} ${dismissable && show ? 'is-active' : null}` }
            role="alert"
            data-js-module={ dismissable ? 'toggleElement' : null }
        >
            { icon ? renderIcon() : null }
            <span className="font-weight-regular">
                { text }
            </span>
            { dismissable ? renderCloseButton() : null }
        </div>
    );
};

Alert.defaultProps = {
    className: 'alert m-b-lg p-a-md br-a-md',
    dismissable: false,
    icon: null,
    show: false,
    type: 'info',
};

Alert.propTypes = {
    className: PropTypes.string,
    dismissable: PropTypes.bool,
    icon: PropTypes.string,
    id: PropTypes.string.isRequired,
    show: PropTypes.bool,
    text: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['danger', 'info', 'success', 'warning']),
};

export default Alert;
